import { formatCnpjInput } from '../../utils/cnpjFormat';

document.addEventListener('input', (event) => {
  if (!event.target.matches('[data-cnpj-input]')) return;

  formatCnpjInput(event);
});
